import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/RealEstate/Hero";
import IndustriesContent from "../components/RealEstate/IndustriesContent";
import PageTitle from "../components/RealEstate/PageTitle";

import '../assets/Webdevelopment.css';



const RealEstate = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  	</div>
	)
}

export default RealEstate;
